module.exports = __webpack_public_path__ + "static/img/shop.ce2842f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/shop.jpg
// module id = BSOn
// module chunks = 1